<edgvr-front-portal-feature-header></edgvr-front-portal-feature-header>
<div class="container-fluid px-5 py-3">
  <router-outlet></router-outlet>
</div>
